let currentScroll = 0

window.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector('.Header')) document.documentElement.style.setProperty('--header-height', document.querySelector('.Header').offsetHeight+'px')
  window.addEventListener('resize', resize)
  window.addEventListener("scroll", scrolling)
  window.addEventListener('keyup', keyPress)
  // document.addEventListener('click', clickAnywhere)
  htmlTopOrNot()
  // blackOrWhiteObserver()

  if (this.document.querySelector('.ManifesteIntro')) animImageIntro()
})

// function clickAnywhere(e) {
//   if(e.target.classList.contains('open-pop-link')) return

//   if(document.querySelector('.product-card_quickshop[data-active="true"]')) {
//     if(!document.querySelector('.product-card_quickshop[data-active="true"] > *').contains(e.target)) {
//       closeQuickshop()
//     }
//   }
//   if(window.innerWidth>=768 && document.querySelector('.oCart[data-active="true"]')) {
//     if(e.clientX<window.innerWidth-490) {
//       document.querySelector('.oCart').dataset.active = false
//       document.body.classList.remove('overflow-hidden');
//     }
//   }
//   if(document.querySelector('.Filters[data-active="true"]')) {
//     if(!document.querySelector('.Filters[data-active="true"] > *').contains(e.target)) {
//       document.querySelector('.Filters').dataset.active = false
//     }
//   }
//   if(document.querySelector('#popup_newsletter[data-active="true"]')) {
//     if(!document.querySelector('#popup_newsletter[data-active="true"] > *').contains(e.target)) {
//       document.querySelector('#popup_newsletter').dataset.active = false
//     }
//   }
//   if(document.querySelector('.product_details[data-active="true"]')) {
//     if(!document.querySelector('.product_details[data-active="true"] > *').contains(e.target)) {
//       document.querySelector('.product_details').dataset.active = false
//     }
//   }
// }
function homeGangTitleAnimation() {
  gsap.registerPlugin(MorphSVGPlugin)
  gsap.registerPlugin(ScrollTrigger)

  gsap.to(".homeGang .svg_a_0", { duration: 1, morphSVG:".homeGang .svg_b_0", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_1", { duration: 1, morphSVG:".homeGang .svg_b_1", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_2", { duration: 1, morphSVG:".homeGang .svg_b_2", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_3", { duration: 1, morphSVG:".homeGang .svg_b_3", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_4", { duration: 1, morphSVG:".homeGang .svg_b_4", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_5", { duration: 1, morphSVG:".homeGang .svg_b_5", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_6", { duration: 1, morphSVG:".homeGang .svg_b_6", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_7", { duration: 1, morphSVG:".homeGang .svg_b_7", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_8", { duration: 1, morphSVG:".homeGang .svg_b_8", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_9", { duration: 1, morphSVG:".homeGang .svg_b_9", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_10", { duration: 1, morphSVG:".homeGang .svg_b_10", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_11", { duration: 1, morphSVG:".homeGang .svg_b_11", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
  gsap.to(".homeGang .svg_a_12", { duration: 1, morphSVG:".homeGang .svg_b_12", ease: 'back.inOut', scrollTrigger: {
    trigger: '.homeGang',
    start: "top bottom",
    end: '+=' + window.innerHeight,
    scrub: true,
  } })
}

function animImageIntro() {
  gsap.to('.manifesteIntro_img', {
    clipPath: 'inset(0% round 4px 4px 4px 4px)',
    ease: 'none',
    scrollTrigger: {
      trigger: '.ManifesteIntro',
      start: "top top",
      end: "bottom 50%",
      scrub: true,
    }
  })
}
function keyPress(e) {
  if(e.code=='Escape') {
    if(document.querySelector('.product-card_quickshop[data-active="true"]')) closeQuickshop()
    if(document.querySelector('.oCart[data-active="true"]')) document.querySelector('.oCart').dataset.active = false
    if(document.querySelector('.Filters[data-active="true"]')) document.querySelector('.Filters').dataset.active = false
    if(document.querySelector('#popup_newsletter[data-active="true"]')) document.querySelector('#popup_newsletter').dataset.active = false
    if(document.querySelector('.product_details[data-active="true"]')) document.querySelector('.product_details').dataset.active = false
    document.body.classList.remove('overflow-hidden');
  }
}

function resize() {
  document.documentElement.style.setProperty('--header-height', document.querySelector('.Header').offsetHeight+'px')
}

function htmlTopOrNot() {
  if(window.scrollY>0) {
    if(document.querySelector('html:not(.scrolled)')) document.documentElement.classList.add('scrolled')
  } else {
    if(document.querySelector('html.scrolled')) document.documentElement.classList.remove('scrolled')
  }
}


function scrolling() {
  if(window.scrollY >= currentScroll) document.querySelector('.Header').classList.add('above')
  else if(document.querySelector('.Header.above')) document.querySelector('.Header.above').classList.remove('above')

  htmlTopOrNot()
  if(document.querySelector('html.nav')) document.documentElement.classList.remove('nav')
  // if(document.querySelector('.HeroFullMedia')) {
  //   if(document.querySelector('.HeroFullMedia').getBoundingClientRect().bottom > window.innerHeight/2) document.querySelector('.Header').classList.add('ghost')
  //   else {
  //     if(document.querySelector('.Header.ghost')) document.querySelector('.Header').classList.remove('ghost')
  //   }
  // }
  currentScroll = window.scrollY
}

function blackOrWhiteObserver() {
  if(!document.querySelector('.white-nav')) return
  // document.querySelector('html.white-nav')
  document.querySelectorAll('#MainContent > section').forEach((el) => {
    if(el.getBoundingClientRect().top<100 && el.getBoundingClientRect().bottom>0) {
      if(el.classList.contains('white-nav')) {
        if(!document.querySelector('html.white-nav')) document.documentElement.classList.add('white-nav')
      } else {
        if(document.querySelector('html.white-nav')) document.documentElement.classList.remove('white-nav')
      }
  }
  })
  /*
  const observer = new IntersectionObserver(function (entries) {
    entries.map((entry) => {
      if(entry.isIntersecting) {
        if(!document.querySelector('html.white-nav')) document.documentElement.classList.add('white-nav')
      } else {
        if(document.querySelector('html.white-nav')) document.documentElement.classList.remove('white-nav')
      }
    })
  }, {
    rootMargin: "0px 0px 0px 0px"
  })
  for (const item of document.querySelectorAll('#MainContent > section')) {
    observer.observe(item)
  }
  */
}

function openQuickshop(quickshop) {
  console.log('openQuickshop')
  quickshop.parentNode.parentNode.querySelector('.product-card_quickshop').dataset.active = true
  document.documentElement.classList.add('pauseSwiper')
}

function openQuickshopWithSize(quickshop, sizeId) {
  quickshop.parentNode.parentNode.parentNode.querySelector('.product-card_quickshop').dataset.active = true
  const selectElement = quickshop.parentNode.parentNode.parentNode.querySelector('.product-card_quickshop select')
  for (var i = 0; i < selectElement.options.length; i++) {
    if (selectElement.options[i].value == sizeId) {
      selectElement.selectedIndex = i
      var event = new Event('change')
      selectElement.dispatchEvent(event)
      break
    }
  }
  quickshop.parentNode.parentNode.parentNode.querySelector('.product-card_quickshop select').dataset.active = true
  document.documentElement.classList.add('pauseSwiper')
}

function closeQuickshop() {
  if(document.querySelector('.product-card_quickshop[data-active="true"]')) document.querySelector('.product-card_quickshop[data-active="true"]').dataset.active = false
  document.documentElement.classList.remove('pauseSwiper')
}

function scrollObserver() {
  Observer.create({
    target: window,
    type: "wheel,scroll",
    onUp: () => monogramDisplay('up'),
    onDown: () => monogramDisplay('down')
  })
}

function goTo(id) {
  window.scrollTo({
    top: document.querySelector("[id='"+id+"']").offsetTop - 100,
    left: 0,
    behavior: 'smooth'
  })
}

function is_touch_device() {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
